import styles from "./ButtonBadge.module.scss";

export interface BadgeButtonProps {
	text: string;
	onClick?: () => void;
	style?: string;
	icon?: React.ReactNode;
	disabled?: boolean
}

const ButtonBadge: React.FC<BadgeButtonProps> = ({ text, onClick, style, icon, disabled }) => {
	return (
		<button disabled={disabled} className={`${styles.badgeButton} ${style}`} onClick={onClick}>
			<span>{text}</span>
			{icon}
		</button>
	);
};
export default ButtonBadge;
